import React from 'react';
import Slider from "react-slick";

const MvpBrands = () => {
    const brands = [
        { logo: "/images/mvp/Dsky.png", name: "DSkylink" },
        { logo: "/images/Portfolio/14.png", name: "Toyota 4x4 Parts Supplier" },
        { logo: "/images/mvp/bluehira.png", name: "Blue Hira Jewelry" },
        { logo: "/images/mvp/holland.png", name: "Holland" },
        { logo: "/images/Portfolio/1.png", name: "InOut Visitor Management System" },
        { logo: "/images/Portfolio/6.png", name: "Mobile Accessories and Top-Up Business" }
    ];

    const slideSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <div className="section section-padding bg-color-light mvp-brands-area pt-5 mt-4" style={{ marginBottom: "10px", paddingBottom: "80px" }}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-3 col-md-12 mb-4 mb-lg-0 text-center text-lg-start pe-lg-4">
                        <h4 className="title fw-bold mb-0 text-dark" style={{ fontSize: "22px", lineHeight: "1.4" }}>
                            Trusted by over <span className="text-primary">1000+</span><br />Clients
                        </h4>
                    </div>
                    <div className="col-lg-9 col-md-12">
                        <div className="mvp-brand-slider">
                            <Slider {...slideSettings}>
                                {brands.map((brand, index) => (
                                    <div className="brand-logo px-3" key={index}>
                                        <div className="d-flex justify-content-center align-items-center mx-auto" style={{ maxWidth: "150px", height: "120px" }}>
                                            {/* Fallback box shown if image not found to ensure layout holds */}
                                            <div className="fallback-logo bg-white shadow-sm border rounded p-3 text-center d-none w-100">Brand</div>
                                            <img
                                                src={process.env.PUBLIC_URL + brand.logo}
                                                alt={brand.name}
                                                className="img-fluid brand-logo-img"
                                                style={{ maxHeight: "100%", maxWidth: "120px", marginLeft: "auto", marginRight: "auto" }}
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.previousSibling.classList.remove('d-none');
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MvpBrands;
